import { formatMetricValue } from "@/grid/core/format-metric";
import type { MetricFormat } from "@/grid/core/types";
import type { PeriodId } from "@/grid/core/types";
import type { StatusColor } from "@/grid/lib/pacing";

export interface PeriodCopy {
  periodLabel: string;
  soFar: string;
  goalLabel: string;
  paceContext: string;
}

const PERIOD_COPY: Record<PeriodId, PeriodCopy> = {
  wtd: {
    periodLabel: "Week to date",
    soFar: "so far this week",
    goalLabel: "weekly target",
    paceContext: "in the week",
  },
  lastWeek: {
    periodLabel: "Last week",
    soFar: "last week",
    goalLabel: "weekly target",
    paceContext: "for that week",
  },
  mtd: {
    periodLabel: "Month to date",
    soFar: "so far this month",
    goalLabel: "monthly target",
    paceContext: "in the month",
  },
  qtd: {
    periodLabel: "Quarter to date",
    soFar: "so far this quarter",
    goalLabel: "quarterly target",
    paceContext: "in the quarter",
  },
};

export function periodCopy(periodId: PeriodId): PeriodCopy {
  return PERIOD_COPY[periodId];
}

export function paceStatusMessage(status: StatusColor): { text: string; className: string } {
  switch (status) {
    case "green":
      return { text: "Ahead of pace!", className: "text-[var(--color-status-green)]" };
    case "yellow":
      return { text: "Close to pace.", className: "text-[var(--color-status-yellow)]" };
    case "red":
      return { text: "Behind pace.", className: "text-[var(--color-status-red)]" };
  }
}

export function formatPacePercent(
  actual: number | null,
  pacingTarget: number | null,
): number | null {
  const resolvedActual = actual ?? 0;
  if (pacingTarget == null || pacingTarget <= 0) return null;
  return Math.round((resolvedActual / pacingTarget) * 100);
}

export function formatDetailAmount(value: number | null | undefined, format: MetricFormat): string {
  return formatMetricValue(value ?? 0, format === "currency" ? "currency" : "number");
}
